// 1 and 5 added for compatibility cases in order of conversion v2020 -> v2021
export type ArtDesBeteiligtenEnum = '1' | '2' | '3' | '4' | '5';

export const ArtDesBeteiligtenEnum = {
    _2: '2' as ArtDesBeteiligtenEnum,
    _3: '3' as ArtDesBeteiligtenEnum,
    _4: '4' as ArtDesBeteiligtenEnum
};

